import { render } from "./RewardsComponent.vue?vue&type=template&id=173825be&scoped=true"
import script from "./RewardsComponent.vue?vue&type=script&lang=js"
export * from "./RewardsComponent.vue?vue&type=script&lang=js"

import "./RewardsComponent.vue?vue&type=style&index=0&id=173825be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173825be"]])

export default __exports__